// What the recorder says about the device and its microphone: whether this
// is an installed app or an Apple device, and the browser's microphone
// refusals turned into what to do.

export const isStandalone = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)").matches ||
    (navigator as unknown as { standalone?: boolean }).standalone === true);

export const isApple = () =>
  typeof navigator !== "undefined" &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

/** The browser's own wording ("Permission denied", "not allowed by the user
 * agent") tells the operator nothing when they never saw a prompt. On iOS a
 * home-screen app keeps its own microphone permission, separate from Safari's,
 * and a single earlier "Don't Allow" is remembered silently. Say what to do. */
export function micErrorMessage(e: Error): string {
  const name = e?.name || "";
  const message = e?.message || "";
  if (name === "NotAllowedError" || /not allowed|permission/i.test(message)) {
    if (isApple() && isStandalone()) {
      return "iPhone hasn't given this app the microphone. Open Settings, then Corvus, and turn Microphone on. If it isn't listed, open the site in Safari, record once to get the prompt, then reopen this app.";
    }
    if (isApple()) {
      return "Safari blocked the microphone. Tap the aA in the address bar, choose Website Settings, set Microphone to Allow, then try again.";
    }
    return "The browser blocked the microphone. Allow it for this site in your browser's site settings, then try again.";
  }
  if (name === "NotFoundError" || name === "OverconstrainedError") return "No microphone found on this device.";
  if (name === "NotReadableError") return "The microphone is busy in another app. Close that and try again.";
  if (name === "SecurityError") return "The microphone needs a secure connection. Open the site over https and try again.";
  return `Microphone not available: ${message || "unknown error"}`;
}
